import * as React from "react";
import { GameFrame } from "./GameFrame";
import { PixiRoot } from "./PixiRoot";
import { Game } from "./game/Game";
import { SideBar } from "./ui/SideBar";
import styles from './Root.sass'
import { RestartableGame } from "./game/RestartableGame";
import * as clsx from "clsx";

export function Root() {
	const [restartableGame, setRestartableGame] = React.useState<{
		restartableGame: RestartableGame | null
	}>({ restartableGame: null });
	React.useEffect(() => {
		const gameRoot = new RestartableGame();
		gameRoot.init().then(() => {
			setRestartableGame({ restartableGame: gameRoot })
			gameRoot.uiUpdateRequested.listen(() => {
				setRestartableGame({ restartableGame: gameRoot });
			});
		});
	}, []);

	if (!restartableGame?.restartableGame) {
		return null
	}

	return <div>
		<GameFrame>
			<div className={styles.root}>
				<div
					className={styles.game}
					onMouseDown={(e) => restartableGame?.restartableGame?.game?.mouse?.onMouseDown(e)}
					onMouseMove={(e) => restartableGame?.restartableGame?.game?.mouse?.onMouseMove(e)}
				>
					{restartableGame?.restartableGame?.game == null ? <>Loading...</> : <></>}
					{restartableGame?.restartableGame?.game && <PixiRoot app={restartableGame.restartableGame.app} />}
				</div>
				{restartableGame?.restartableGame?.game && <SideBar game={restartableGame.restartableGame.game} />}

				{
					restartableGame.restartableGame.game?.over && <div className={clsx(
						styles.gameOver,
						restartableGame.restartableGame.game?.over === 'lost' && styles.lost,
						restartableGame.restartableGame.game?.over === "won" && styles.won
					)}>
						<div >
							{restartableGame.restartableGame.game?.over === 'lost' ? 'YOU DIED' : 'ASSIMILATION ACHIEVED'}
						</div>
						<div className={styles.restart} onClick={() => location.reload()}>
							RESTART
						</div>
					</div>
				}
			</div>
		</GameFrame >
	</div >;
}
